import tinyEditor from "./tiny-editor";
export default tinyEditor;
